import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-page-subheader',
  templateUrl: './page-subheader.component.html',
  styleUrls: ['./page-subheader.component.scss'],
})
export class PageSubheaderComponent {
  @Input() backLabel = 'Back';
  @Input() showBack = true;
  @Input() showSearch = true;
  @Input() title?: string;
  @Input() meta?: string;
  @Input() titleLoading = false;

  private _search = '';

  @Input()
  set search(value: string) {
    this._search = value ?? '';
    this.searchValue = this._search;
  }

  get search(): string {
    return this._search;
  }

  searchValue = '';
  @Input() searchPlaceholder = 'Search';
  @Input() searchAriaLabel?: string;
  @Input() searchPrefixImageSrc?: string;
  @Input() searchClearImageSrc?: string;
  @Input() searchDisabled = false;

  @Output() back = new EventEmitter<void>();
  @Output() searchChange = new EventEmitter<string>();
  @Output() searchInput = new EventEmitter<string>();
  @Output() searchCleared = new EventEmitter<void>();

  readonly titleSkeletonTheme = {
    width: '320px',
    height: '36px',
    marginBottom: '0',
    borderRadius: '8px',
    backgroundColor: '#e2e8f0',
  };

  onBack(): void {
    this.back.emit();
  }

  onSearchChange(value: string): void {
    this.searchValue = value ?? '';
    this.searchChange.emit(this.searchValue);
  }
}

